import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AddButton, CustomDelete, FullTable, SelectedFilters } from 'components';
import { useModal, User } from 'utils';
import { wishlistActions } from 'store';
import { WishlistDetails, WishlistForm } from './fragments';
import {
    WISHLIST_LIST_ACTION,
    WISHLIST_PAGE_SIZE,
    wishlistBody,
    wishlistCategoryList,
    wishlistHead,
    wishlistNoMatches,
    wishlistNotYet,
    wishlistStatusList,
} from './constants';

const DELETE_ACTION_TYPE = 'DELETE_WISHLIST_ITEM';

export const Wishlist = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const info = location?.state;
    const { userInfo } = User();
    const { open } = useModal();
    const list = useSelector((state) => state.wishlist.wishlistItems);

    const renderParams = () => {
        const params = { skip: info?.skip || 0, limit: WISHLIST_PAGE_SIZE };
        if (info?.category) params.category = info.category;
        if (info?.status) params.status = info.status;
        if (info?.searchValue) params.search = info.searchValue;
        return params;
    };

    const fetchList = (load) => dispatch(wishlistActions.getWishlistItems(renderParams(), load));

    useEffect(() => {
        fetchList();
    }, [info]);

    const markSeen = (item) => item?.hasUpdate && dispatch(wishlistActions.markWishlistSeen(item.id));

    const openDetails = (item, opts = {}) => {
        markSeen(item);
        open(<WishlistDetails id={item?.id} requestParams={renderParams()} {...opts} />);
    };

    const handleActions = (item, name) => {
        if (name === 'view') openDetails(item);
        if (name === 'edit') openDetails(item, { startInEdit: true });
        if (name === 'delete') {
            open(
                <CustomDelete
                    info="Delete wishlist request?"
                    text={`Are you sure you want to delete "${item?.title}"? Its comments and attachments are deleted with it. This action cannot be undone.`}
                    handleDel={() => dispatch(wishlistActions.deleteWishlistItem(item?.id, renderParams()))}
                    actionType={DELETE_ACTION_TYPE}
                    innerText="Delete"
                />
            );
        }
    };

    const hasFilters = !!(info?.category || info?.status || info?.searchValue);

    return (
        <div>
            <div className="space-between-align-end">
                <div />
                <AddButton
                    styles={{ whiteSpace: 'nowrap' }}
                    text="New Request"
                    handleClick={() => open(<WishlistForm requestParams={renderParams()} />)}
                />
            </div>

            <div style={{ marginTop: 12 }}>
                <SelectedFilters
                    filtersList={[
                        { name: 'Category', key: 'category', options: wishlistCategoryList },
                        { name: 'Status', key: 'status', options: wishlistStatusList },
                        { name: 'Search', key: 'searchValue', companions: ['searchKey'] },
                    ]}
                    doNotCrop
                />
            </div>

            <FullTable
                head={wishlistHead}
                body={wishlistBody(userInfo?.id, () => fetchList('noLoad'), markSeen)}
                loadingType={WISHLIST_LIST_ACTION}
                list={list?.data}
                listCount={list?.count}
                handleClick={(id, item) => openDetails(item)}
                handleClickButton={handleActions}
                notYet={hasFilters ? wishlistNoMatches : wishlistNotYet}
                margin="12px 0 0 0"
            />
        </div>
    );
};
